import { PlusCircle } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import AddMachineForm from './AddMachineForm';
import { selectUserId } from '../auth.slice';
import { IUser } from '../auth';

function AddMachineModal({ user }: { user: IUser }) {
  const currentUser = useSelector(selectUserId);
  const [dialogOpen, setDialogOpen] = useState(false);
  if (!user || !currentUser || currentUser !== user._id) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button>
          <PlusCircle className="mr-2 h-4 w-4" />
          Add Machine
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New CNC Machine</DialogTitle>
        </DialogHeader>
        <AddMachineForm
          onSucess={() => {
            setDialogOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}

export default AddMachineModal;
